import React from "react";
import ImgGramInfoPage from "./ImgGramInfoPage";

const GrampanchayatInfo = () => {
  return (
    <>
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-8">
        {/* Page Heading */}
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          ग्रामपंचायत चांडोली खुर्द
        </h1>

        {/* General Information */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            गावाची सर्वसाधारण माहिती (सन २०२५/२६)
          </h2>
          <ul className="text-gray-700 space-y-1 leading-relaxed">
            <li>भौगोलिक स्थान: 19.016284 LATITUDE, 73.976712 LONGITUDE</li>
            <li>जिल्हा पुणे पासून: 60 कि.मी</li>
            <li>तालुका आंबेगाव (घोडेगाव) पासून: 19 कि.मी</li>
            <li>एकूण वाड्या वस्त्या: गावठाण, काटे मळा, मधला मळा, ब्राह्मण मळा, पाईन वस्ती/कुंडवस्ती, पोखरकर मळा, बांगर मळा, खालचा मळा</li>
            <li>एकूण लोकसंख्या (2011 Census): पुरुष 1000, स्त्री 843, एकूण 1843</li>
            <li>एकूण कुटुंब संख्या: 380</li>
            <li>शौचालय असलेली कुटुंबे: 380</li>
            <li>ग्रामपंचायत खातेदार: 417</li>
            <li>एकूण घर मिळकती संख्या: 711 (शासकीय इमारती: 10)</li>
          </ul>
        </section>

        {/* Geographic and Agriculture */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            भौगोलिक माहिती व प्रमुख पिके
          </h2>
          <ul className="text-gray-700 space-y-1 leading-relaxed">
            <li>एकूण क्षेत्रफळ: 362.36 हेक्टर</li>
            <li>बागायती क्षेत्र: 297.59 हेक्टर</li>
            <li>गावठाण क्षेत्र: 5.56 हेक्टर</li>
            <li>तलाव: 0.07 हेक्टर</li>
            <li>अकृषिक वापर: 88,588 चौरस मीटर</li>
            <li>लागवड अयोग्य क्षेत्र: 30.01 हेक्टर</li>
            <li>गायरान क्षेत्र: 21.63 हेक्टर</li>
            <li>वन क्षेत्र: नाही</li>
            <li>प्रमुख पिके:
              <ul className="ml-4 list-disc">
                <li>खरीप हंगाम: बाजरी, ज्वारी, फ्लॉवर, कोबी, बीट चारा पिक</li>
                <li>रब्बी हंगाम: मका, गाजर, फ्लॉवर, कोबी, बीट, कांदा</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Awards */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">पुरस्कार</h2>
          <ul className="text-gray-700 space-y-1 leading-relaxed list-disc list-inside">
            <li>संत गाडगे बाबा ग्रामस्वच्छता अभियानातील सर्वोत्कृष्ट कामगिरी – आबासाहेब खेडकर स्मृती विशेष पुरस्कार</li>
            <li>महात्मा गांधी तंटामुक्त गाव मोहीम पुरस्कार</li>
            <li>पर्यावरण संतुलित समृद्ध ग्राम पुरस्कार – सन २०१०/२०११</li>
            <li>संत गाडगे बाबा ग्रामस्वच्छता अभियान जिल्हा स्तरावर प्रथम क्रमांक</li>
            <li>पुणे जिल्हा परिषदेचा आदर्श कृषी ग्राम पुरस्कार – सन २०११/२०१२</li>
            <li>निर्मल ग्राम पुरस्कार – सन २००८</li>
          </ul>
        </section>

        {/* Education */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">शैक्षणिक सुविधा</h2>
          <ul className="text-gray-700 space-y-2">
            <li>
              <strong>अंगणवाडी संख्या:</strong> २
              <ul className="ml-4 list-disc">
                <li>गावठाण: मुले-10, मुली-4, एकूण 14, सेविका-1, मदतनीस-1</li>
                <li>काटे मळा: मुले-16, मुली-11, एकूण 27, सेविका-1, मदतनीस-1</li>
              </ul>
            </li>
            <li>
              <strong>जिल्हा परिषद प्राथमिक शाळा:</strong>
              <ul className="ml-4 list-disc">
                <li>गावठाण शाळा (1ली-5वी): मुले 75, मुली 55, एकूण 130, शिक्षक 7, वर्ग खोल्या 8</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Water Facilities */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">पिण्याचे पाणी</h2>
          <ul className="text-gray-700 space-y-1 list-disc list-inside">
            <li>सार्वजनिक विहीर: 2</li>
            <li>नळपाणीपुरवठा योजना: गावठाणसाठी 2 टाकी (40,000 लिटर)</li>
            <li>हातपंप: 3</li>
            <li>नदी: घोडनदी</li>
            <li>बंधारे: पाझर तलाव 1, के टी बंधारा 1</li>
          </ul>
        </section>

        {/* Health Facilities */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">आरोग्य सुविधा</h2>
          <ul className="text-gray-700 space-y-1 list-disc list-inside">
            <li>प्राथमिक आरोग्य उपकेंद्र: 0</li>
            <li>आरोग्य सेविका: 0</li>
            <li>आरोग्य सेवक: 0</li>
            <li>आशा सेविका: 1</li>
          </ul>
        </section>

        {/* Transport & Electricity */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">दळवळण आणि विद्युत सुविधा</h2>
          <ul className="text-gray-700 space-y-1 list-disc list-inside">
            <li>बस स्थानक: 0</li>
            <li>पोष्ट ऑफिस: 0</li>
            <li>दूरध्वनी केंद्र: 0</li>
            <li>पथ दिव्यांची संख्या: 92 (सर्व चालू)</li>
            <li>सौर हायमास्ट: 3, हाय मास्ट: 2</li>
          </ul>
        </section>

        {/* Government Buildings */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">गावातील शासकीय इमारती</h2>
          <ul className="text-gray-700 space-y-1 list-disc list-inside">
            <li>ग्रामपंचायत कार्यालय: 1</li>
            <li>ग्रामपंचायत वाचनालय: 1</li>
            <li>व्यायाम शाळा: 1</li>
            <li>समाजमंदिर: 2</li>
            <li>अंगणवाडी इमारत: 3</li>
            <li>प्राथमिक शाळा वर्ग खोल्या: 7</li>
          </ul>
        </section>

        {/* Festivals & Temples */}
        <section className="bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">वार्षिक उत्सव व धार्मिक स्थळे</h2>
          <ul className="text-gray-700 space-y-1 list-disc list-inside">
            <li>यात्रा उत्सव</li>
            <li>अखंड हरिनाम सप्ताह चांडोली खुर्द</li>
            <li>भैरवनाथ यात्रा उत्सव चांडोली खुर्द</li>
            <li>भैरवनाथ मंदिर, मुक्ताई मंदिर, कळमजाई मंदिर, हनुमान मंदिर, पीर साहेब मंदिर</li>
          </ul>
        </section>
      </div>
      <ImgGramInfoPage />
    </>
  );
};

export default GrampanchayatInfo;
